import { render, staticRenderFns } from "./pdfUpload.vue?vue&type=template&id=70bf1bf2&scoped=true"
import script from "./pdfUpload.vue?vue&type=script&lang=js"
export * from "./pdfUpload.vue?vue&type=script&lang=js"
import style0 from "./pdfUpload.vue?vue&type=style&index=0&id=70bf1bf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf1bf2",
  null
  
)

export default component.exports